import { put } from "@redux-saga/core/effects";
import axios from "axios";
import { api } from "../../../services/api";

import { AuthService, GetGuestTokensResponse } from "../../../services/auth";
import { IErrorType } from "./../../types/errors.d";

import { initUserFailure, initUserSuccess } from "../actionCreators";
import { IUserTypes } from "../types";

export function* initUserSaga() {
    let userType = localStorage.getItem("userType") as IUserTypes;
    let token = localStorage.getItem("token") as string;
    let refresh_token = localStorage.getItem("refresh_token") as string;

    if (!token) {
        userType = IUserTypes.GUEST;

        try {
            const {
                data: { data },
            }: GetGuestTokensResponse = yield AuthService.getGuestTokens();

            token = data.token;
            refresh_token = data.refresh_token;

            yield localStorage.setItem("token", token as string);
            yield localStorage.setItem("refresh_token", refresh_token as string);
            yield localStorage.setItem("userType", userType as string);
        } catch (error) {
            if (axios.isAxiosError(error))
                yield put(
                    initUserFailure({ errorType: IErrorType.AXIOS, data: error.response ? error.response.data : null }),
                );
            else yield put(initUserFailure({ errorType: IErrorType.NATIVE, data: error }));

            return null;
        }
    }

    yield (api.defaults.headers.common["x-access-token"] = token);
    yield put(initUserSuccess({ token, refresh_token, userType }));
}
